import _ from 'underscore';
import { FILTER_ISSUED } from '../filter';
import { WS_STATUSES } from 'routes/OperationsCommercial/components/Commercial.constants';
import { Logger } from 'common/logger';

export const measurementAttributes = [
    'active_power',
    'reactive_power',
    'wind_speed',
    'nacelle_direction',
    'ambient_temperature',
];

export const turbineDefaults = {
    // calculated attributes
    name: null,
    string: null,
    substation: null,
    location: null,
    hidden: false,
    dimmed: false,
    isActive: false,
    numericName: 0,

    secondaryStatus: [],

    data: {}, // data.values[measurement_type]

    // attributes that directly coming from the API

    person_count: {
        value: null,
    },
    state: {
        value: '',
    },
    reactive_power: {
        value: null,
        unit: '',
    },
    ambient_temperature: {
        value: null,
        unit: '',
    },
    ts: { value: null },
    last_data_update_time: { value: null },
    last_update_time: null,
    received_id: null,
    nacelle_direction: {
        value: null,
        unit: '',
    },
    is_marked_unavailable: {
        value: null,
    },
    is_visiting: {
        value: null,
    },
    is_surrendered: {
        value: null,
    },
    persons: { value: null },
    key: {
        value: '',
    },
    active_power: {
        value: null,
        unit: '',
    },
    inconsistency_count: {
        value: null,
    },
    wind_speed: {
        value: null,
        unit: '',
    },
    frequency: {
        value: null,
        unit: '',
    },
    alarm_count: {
        value: 0,
    },
    control_mode: {
        value: '',
    },
    is_released: {
        value: null,
    },
    too_many_people_warning: {
        value: null,
    },
    notes: {
        value: [],
    },
    exceptions: {
        value: [],
    },
    restrictions: {
        value: false,
    },
    measurementAttributes,
};

export const statusDenormalize = (a) => {
    // tmp solution until we settle with statuses and API format
    // TODO: secondary status might be plural, think thru
    // var a = this.attributes; // shortcut
    const secondaryStatus = [];

    if (a.person_count.value && a.person_count.value > 0) {
        secondaryStatus.push('is-occupied');
    }

    if (a.is_marked_unavailable.value) {
        secondaryStatus.push('is-unavailable');
    }

    if (a.inconsistency_count.value > 0) {
        secondaryStatus.push('is-inconsistent');
    }

    if (a.restrictions.value === true) {
        secondaryStatus.push('has-restriction');
    }

    if (a.planned_work_orders && a.planned_work_orders.value.length > 0) {
        secondaryStatus.push(FILTER_ISSUED);
    }

    const state = a.state.value ? a.state.value : '';

    const status = WS_STATUSES[state];

    if (status === undefined) {
        Logger.error('State not assignable to Status:', state);
    }

    return {
        status,
        secondaryStatus,
    };
};

export const getPowerValue = (model) =>
    model && model.active_power && typeof model.active_power.value === 'number'
        ? // mega watt with one decimal
          (Number(model.active_power.value) / 1000).toFixed(1)
        : '';
